import { Validation } from '@vuelidate/core';
import { Ref } from 'vue';

export default function validateState(
  key: string,
  v$: Ref<Validation>,
): boolean | null {
  const field = v$.value[key];
  const dirty = field?.$dirty;
  const error = field?.$error;

  return !dirty ? null : !error;
}
